module.exports = __webpack_public_path__ + "img/kuan_nav.b928f7fb.png";